import {GENERATE_INSTRUCTION_TEMPLATE} from './chatbot/prompts.js';
import {CHANNEL} from './integrationChannels.js';

export const LABEL_RESOLVE = {
  THATS_HELPED: 'thats_helped',
  THAT_ANSWERED_MY_QUESTION: 'that_answered_my_question',
  ALL_SET_THANKS: 'all_set_thanks'
};

export const LABEL_TRANSFER = {
  TALK_TO_A_PERSON: 'talk_to_a_person',
  SPEAK_TO_AN_AGENT: 'speak_to_an_agent',
  NEED_MORE_HELP: 'need_more_help'
};

export const DEFAULT_CUSTOM_INSTRUCTION = `Instructions should follow this structure: Role, Knowledge, Communication style, Key guidelines, and Boundaries.`;

export const ASK_FOR_MORE = {
  DONT_ASK: 'dont_ask',
  ASK_FOR_MORE_INFO: 'ask_for_more_info'
};

export const AI_BACKUP = {
  DONT_ALLOW: 'dont_allow',
  ALLOW_OFFLINE_HOUR: 'allow_offline_hour',
  ALLOW_ALWAYS: 'allow_always'
};

/** @type {App.AIAssistantSettings} */
export const DEFAULT_AI_ASSISTANT_SETTINGS = {
  welcomeMessage: `Hello {{customer_name}} 👋 I'm Chatty AI assistant, here to help you find what you're looking for. How can I help you?`,
  topics: [],
  enabledFaqs: false,
  enabledProducts: false,
  enableMultiCurrency: true,
  aiBackup: AI_BACKUP.ALLOW_OFFLINE_HOUR,
  channels: [CHANNEL.ONLINE_STORE],
  botAvatar: 'AVATAR_ICON_1',
  botAvatarUrl: '',
  botName: 'Chatty AI',
  customInstruction: '',
  hasInstruction: false,
  hasTested: false,
  industry: '',
  isShowContactForm: false,
  supportEmails: '',
  enableAfterSalesSupport: 'inactive',
  enableOrderTracking: 'active',
  enableHumanAgentRequest: 'active',
  aiAssistantMode: 'always'
};

export const LABEL_RESOLVE_LIST = [
  `That's helpful`,
  'That answered my question',
  'All set, thanks!'
];

export const LABEL_TRANSFER_LIST = ['Talk to a person', 'Speak to an agent', 'Need more help'];
